import {
  HomeIcon,
  ChartBarIcon,
  UserCircleIcon,
  BellIcon,
  TableCellsIcon,
  ArrowLeftOnRectangleIcon,
  BriefcaseIcon,
  BanknotesIcon,
} from "@heroicons/react/24/solid";
// import ControllerListings from "components/listings-controller";
// import PlanecheckListings from "components/listings-planecheck";
import AdminPanel from "pages/dashboard/AdminPanel";
// import ListingAggregations from "pages/dashboard/ListingAggregations";
// import NewListings from "pages/dashboard/NewListings";
// import Overview from "../pages/dashboard/Overview";
// import { History, Search, Timeline } from "@mui/icons-material";
// import { ListingHistory } from "../components/ListingHistory";
import { Dashboard, ErrorOutlineSharp, Fence, Language, Radar, Search} from "@mui/icons-material";
import Profile from "pages/dashboard/Profile";
import { AdjustmentsHorizontalIcon, DocumentTextIcon, InboxArrowDownIcon, UsersIcon } from "@heroicons/react/24/outline";
import { SearchListings } from "../components/SearchListings";
// import Home from "pages/dashboard/home";
// import Tables from "../pages/dashboard/tables";
import ControllerListingsAll from "../components/listings-controller-all";
import PlanecheckListingsAll from "../components/listings-planecheck-all";
// import GlobalairListingsAll from "../components/listings-globalair-all";
import ListingAggregationsV1 from "../pages/dashboard/ListingAggregationsV1";
// import ListingsPageRelisted from "../pages/dashboard/ListingsPageRelisted";
import DataCleaningPanel from "../pages/dashboard/DataCleaningPanel";
import AllListings from "../pages/dashboard/AllListings";
import { BrokerView } from "../pages/dashboard/BrokerView";
// import DealerView from "../pages/dashboard/DealerView";
// import ReprocessingView from "../pages/dashboard/ReprocessingView";
// import FXRateView from "../pages/dashboard/FXRateView";
import DashboardPage from "../pages/dashboard/DashboardPage";
import ListingAnalytics from "../pages/dashboard/ListingAnalytics";
import DelistedView from "../pages/dashboard/DelistedView";
// import FailedListings from "../components/FailedListings";
import MarketReportPage from "../pages/dashboard/MarketReportPage";
// import UserPanel from "../pages/dashboard/UserPanel";
// import SalesDataIntegration from "../pages/dashboard/SalesDataIntegration";
import PPHome from "../pages/dashboard/PPHome";
import TradeAPlaneListingsAll from "../components/listings-trade-a-plane-all";
import CirrusListingsAll from "../components/listings-cirrus-all";
import CirrusScrapeConfigPage from "../pages/dashboard/CirrusScrapeConfigPage";
import ListingAnalyticsLMTN from "../pages/dashboard/ListingAnalyticsLMTN";
import SellerClassification from "../pages/dashboard/SellerClassification";
import ReportEditorPage from "../pages/dashboard/ReportEditorPage";
import ReportsListPage from "../pages/dashboard/ReportsListPage";
import DraftsListPage from "../pages/dashboard/DraftsListPage";
import CirrusConfiguratorPage from "../pages/dashboard/CirrusConfiguratorPage";
import ReportAnalyticsPage from "../pages/dashboard/ReportAnalyticsPage";
import UserManagementPage from "../pages/dashboard/UserManagementPage";
import FailedListings from "../components/FailedListings";
import SalesCompsPage from "../pages/dashboard/SalesCompsPage";
import AircraftPostSalesPage from "../pages/dashboard/AircraftPostSalesPage";
// import ValuationDashboard from "../pages/dashboard/ValuationDashboard";
// import RunValuation from "../pages/dashboard/RunValuation";
// import ValuationResult from "../pages/dashboard/ValuationResult";
// import ValuationTemplates from "../pages/dashboard/ValuationTemplates";
import ValuationSubmissions from "../pages/dashboard/ValuationSubmissions";
import WebStatsPage from "../pages/dashboard/WebStatsPage";
import CirrusNetworkPage from "../pages/dashboard/CirrusNetworkPage";
import EstSalesPage from "../pages/dashboard/EstSalesPage";
// import { CalculatorIcon } from "@heroicons/react/24/outline";

const icon = {
  className: "w-5 h-5 text-inherit",
};

export const routes = [
  {
    layout: "dashboard",
    pages: [
      {
        icon: <HomeIcon {...icon} />,
        name: "Home",
        path: "/home",
        element: <PPHome />,
        role: "admin"
      },
      {
        icon: <UserCircleIcon {...icon} />,
        name: "profile",
        path: "/profile",
        element: <Profile />,
      },
      {
        icon: <TableCellsIcon {...icon} />,
        name: "Controller",
        path: "/controller-listings-all",
        element: <ControllerListingsAll />,
        role: "admin"
      },
      {
        name: "Planecheck",
        icon: <TableCellsIcon {...icon} />,
        path: "/planecheck-listings-all",
        element: <PlanecheckListingsAll />,
        role: "admin"
      },
      {
        name: "Trade-a-plane",
        icon: <TableCellsIcon {...icon} />,
        path: "/trade-a-plane-listings-all",
        element: <TradeAPlaneListingsAll />,
        role: "admin"
      },
      {
        name: "AircraftPost",
        icon: <TableCellsIcon {...icon} />,
        path: "/aircraftpost",
        element: <AircraftPostSalesPage />,
        role: "admin",
      },
      {
        name: "Cirrus",
        icon: <TableCellsIcon {...icon} />,
        path: "/cirrus-listings-all",
        element: <CirrusListingsAll />,
        role: "admin",
      },
      // {
      //     icon: <PhotoIcon {...icon} />,
      //     name: "Sales Data",
      //     path: "/sales-data-integration",
      //     element: <SalesDataIntegration />,
      //     role: "admin"
      //   },
        {
          icon: <ErrorOutlineSharp {...icon} />,
          name: "Failed Listings",
          path: "/failed-listings",
          element: <FailedListings />,
          role: "admin"
        },
      // {
      //   icon: <TableCellsIcon {...icon} />,
      //   name: "Ag Grid Test",
      //   path: "/ag-grid-test",
      //   element: <AGGridTest />,
      //   role: "admin"
      // },
      // {
      //   icon: <HomeIcon {...icon} />,
      //   name: "New Listings",
      //   path: "/new-listings",
      //   element: <NewListingsV2 />,
      //   // role: "admin"
      // },
      {
        icon: <Dashboard {...icon} />,
        name: "Dashboard",
        path: "/dashboard",
        element: <DashboardPage />,
        // role: "admin"
      },
      {
        icon: <Fence {...icon} />,
        name: "Market Reports",
        path: "/market-reports",
        element: <MarketReportPage />,
        hidden: true,
      },
      {
        icon: <ChartBarIcon {...icon} />,
        name: "Reports",
        path: "/reports",
        element: <ReportsListPage />,
        hidden: true,
      },
      {
        icon: <DocumentTextIcon {...icon} />,
        name: "Reports",
        path: "/drafts",
        element: <DraftsListPage />,
      },
      {
        icon: <ChartBarIcon {...icon} />,
        name: "Report Analytics",
        path: "/report-analytics",
        element: <ReportAnalyticsPage />,
        role: "reportAnalytics"

      },
      {
        icon: <ChartBarIcon {...icon} />,
        name: "Report Editor",
        path: "/report-editor",
        element: <ReportEditorPage />,
        hidden: true,
      },
      {
        name: "Report Editor Draft",
        path: "/report-editor/:draftId",
        element: <ReportEditorPage />,
        hidden: true,
      },
      {
        icon: <BanknotesIcon {...icon} />,
        name: "Sales Comps",
        path: "/sales-comps",
        element: <SalesCompsPage />,
        role: "compsEditor",
      },
      // {
      //   icon: <CalculatorIcon {...icon} />,
      //   name: "Valuations",
      //   path: "/valuations",
      //   element: <ValuationDashboard />,
      // },
      // {
      //   name: "Run Valuation",
      //   path: "/valuations/run",
      //   element: <RunValuation />,
      //   hidden: true,
      // },
      // {
      //   name: "Valuation Result",
      //   path: "/valuations/runs/:id",
      //   element: <ValuationResult />,
      //   hidden: true,
      // },
      // {
      //   icon: <CalculatorIcon {...icon} />,
      //   name: "Valuation Templates",
      //   path: "/valuation-templates",
      //   element: <ValuationTemplates />,
      //   role: "admin",
      // },
      {
        icon: <InboxArrowDownIcon {...icon} />,
        name: "Valuation Requests",
        path: "/valuation-submissions",
        element: <ValuationSubmissions />,
      },
      {
        icon: <Language {...icon} />,
        name: "Web Stats",
        path: "/web-stats",
        element: <WebStatsPage />,
      },
      {
        icon: <Radar {...icon} />,
        name: "Cirrus Network",
        path: "/cirrus-network",
        element: <CirrusNetworkPage />,
        role: "cirrusNetwork",
      },
      {
        icon: <BanknotesIcon {...icon} />,
        name: "Est Aircraft Sales",
        path: "/est-sales",
        element: <EstSalesPage />,
        role: "estSalesReport",
      },
      {
        icon: <HomeIcon {...icon} />,
        name: "All Listings",
        path: "/all-listings",
        element: <AllListings />,
      },
      {
        icon: <ArrowLeftOnRectangleIcon {...icon} />,
        name: "Delisted",
        path: "/delisted",
        element: <DelistedView />,
        role: "admin"

      },
      // {
      //   icon: <HomeIcon {...icon} />,
      //   name: "Relisted",
      //   path: "/listings-rl",
      //   element: <ListingsPageRelisted />,
      //   role: "admin"
      // },
      // {
      //   icon: <ChartBarIcon {...icon} />,
      //   name: "price analysis",
      //   path: "/listing-aggregations",
      //   element: <ListingAggregations />,
      //   role: "admin"
      // },
      {
        icon: <ChartBarIcon {...icon} />,
        name: "price analysis",
        path: "/listing-aggregations-v1",
        element: <ListingAggregationsV1 />,
        role: "admin"
      },
      {
        icon: <BriefcaseIcon {...icon} />,
        name: "broker view",
        path: "/broker-view",
        element: <BrokerView />,
        // role: "admin"
      },
      {
        icon: <ChartBarIcon {...icon} />,
        name: "Seller Classification",
        path: "/seller-classification",
        element: <SellerClassification />,
        role: "admin"
      },
      // {
      //   icon: <ChartBarIcon {...icon} />,
      //   name: "dealer view",
      //   path: "/dealer-view",
      //   element: <DealerView />,
      //   role: "admin"
      // },
      // {
      //   icon: <ChartBarIcon {...icon} />,
      //   name: "re-processing view",
      //   path: "/reprocessing-view",
      //   element: <ReprocessingView />,
      //   role: "admin"
      // },
      // {
      //   icon: <ChartBarIcon {...icon} />,
      //   name: "FX rate view",
      //   path: "/fx-rate-view",
      //   element: <FXRateView />,
      //   role: "admin"
      // },

      // {
      //   icon: <Timeline {...icon} />,
      //   name: "Listings Overview",
      //   path: "/listings-overview",
      //   element: <Overview />,
      // },
      // {
      //   icon: <History {...icon} />,
      //   name: "History",
      //   path: "/listings-history",
      //   element: <ListingHistory />,
      // },
      {
        icon: <Search {...icon} />,
        name: "Search",
        path: "/search",
        element: <SearchListings />,
      },
      {
        icon: <AdjustmentsHorizontalIcon {...icon} />,
        name: "Admin Panel",
        path: "/admin-panel",
        element: <AdminPanel />,
        role: "admin"
      },
      {
        icon: <UsersIcon {...icon} />,
        name: "User Management",
        path: "/user-management",
        element: <UserManagementPage />,
        role: "userManage"
      },
      // {
      //   icon: <UserCircleIcon {...icon} />,
      //   name: "User Panel",
      //   path: "/user-panel",
      //   element: <UserPanel />,
      //   role: "admin"
      // },
      // {
      //   name: "Globalair",
      //   icon: <TableCellsIcon {...icon} />,
      //   path: "/globalair-listings-all",
      //   element: <GlobalairListingsAll />,
      //   role: "admin"
      // },
      {
        name: "Listing Analytics",
        icon: <TableCellsIcon {...icon} />,
        path: "/listing-analytics",
        element: <ListingAnalytics />,
        role: "admin"

      },
      {
        name: "Listing Analytics LMTN",
        icon: <TableCellsIcon {...icon} />,
        path: "/listing-analytics-lmtn",
        element: <ListingAnalyticsLMTN />,
        role: "admin"

      },
      {
        name: "Data Cleaning",
        icon: <BellIcon {...icon} />,
        path: "/data-cleaning",
        element: <DataCleaningPanel />,
        role: "admin"
      },
      {
        name: "Cirrus Configurator",
        icon: <AdjustmentsHorizontalIcon {...icon} />,
        path: "/cirrus-configurator",
        element: <CirrusConfiguratorPage />,
        role: "admin"
      },
      {
        name: "Cirrus Scrape Config",
        icon: <AdjustmentsHorizontalIcon {...icon} />,
        path: "/cirrus-scrape-config",
        element: <CirrusScrapeConfigPage />,
        role: "admin"
      },
      // {
      //   name: "Table",
      //   icon: <BellIcon {...icon} />,
      //   path: "/tables",
      //   element: <Tables />,
      // }
    ],
  },
  // {
  //   title: "detail routes",
  //   layout: "details",
  //   routes: [
  //     {
  //       icon: <ArrowRightOnRectangleIcon {...icon} />,
  //       name: "listing details",
  //       path: "/listings/:slug",
  //       element: <Login />,
  //     }
  //   ],
  // },
   // {
  //   title: "auth pages",
  //   layout: "auth",
  //   pages: [
  //     {
  //       icon: <ArrowRightOnRectangleIcon {...icon} />,
  //       name: "sign in",
  //       path: "/sign-in",
  //       element: <Login />,
  //     },
  //     {
  //       icon: <UserPlusIcon {...icon} />,
  //       name: "sign up",
  //       path: "/sign-up",
  //       element: <Signup />,
  //     },
  //   ],
  // },
  
];

export default routes;
